import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMidwayToken, decodeJwt } from '../auth/midway';
import { setAuthToken } from '../services/api';

interface AuthState {
   user: string;
   token: string;
   isAuthenticated: boolean;
}

const AuthContext = createContext<AuthState>({ user: '', token: '', isAuthenticated: false });

export const useAuth = () => useContext(AuthContext);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
   const [auth, setAuth] = useState<AuthState>({ user: '', token: '', isAuthenticated: false });
   const [loading, setLoading] = useState(true);

   useEffect(() => {
       getMidwayToken().then(token => {
           const { sub } = decodeJwt(token);
           setAuthToken(token);
           setAuth({ user: sub, token, isAuthenticated: true });
           setLoading(false);
       }).catch(() => {});
   }, []);

   // Refresh token before expiry
   useEffect(() => {
       if (!auth.token) return;
       const { exp } = decodeJwt(auth.token);
       const refreshIn = (exp * 1000 - Date.now()) - 60000;
       if (refreshIn <= 0) return;
       const timer = setTimeout(() => {
           getMidwayToken().then(token => {
               const { sub } = decodeJwt(token);
               setAuthToken(token);
               setAuth({ user: sub, token, isAuthenticated: true });
           }).catch(() => {});
       }, refreshIn);
       return () => clearTimeout(timer);
   }, [auth.token]);

   if (loading) return <div>Authenticating...</div>;
   return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};